import React, { Component } from 'react';

import Blank from '../../../hoc/Blank/Blank';
import Button from '../../UI/Button/Button';

class DeleteDriverWarningModal extends Component {
    render () {
        return (
            <Blank>
                <h3>Delete Driver Warning</h3>
                <p>Please confirm that you would like to 
                <br />delete this driver
                </p>                
                <Button btnType="Success" clicked={this.props.delete}>DELETE</Button>  <Button btnType="Danger" clicked={this.props.cancel}>CANCEL</Button>
            </Blank>
        );
    }
}

export default DeleteDriverWarningModal;


// WEBPACK FOOTER //
// ./src/components/SuccessModals/DeleteDriverWarningModal/DeleteDriverWarningModal.js